import finance_team_refund_routes from 'routes/finance-team/refund'
import {
  RevenueListPage,
  RevenueDetailPage,
  RevenueTransferPage
} from 'domains/revenue'

import {
  PaymentBankTransferListPage,
  PaymentBankTransferConfirmRejectPage,
  PaymentBankTransferCreatePage
} from 'domains/payment-bank-transfer'


import {
  CustomerOrderPaymentListPage,
  CustomerOrdersDownloadUnlinkedBankTransactionCsvPage
} from 'domains/customer-order'

import {
  PaymentMethodDetailPage,
  PaymentMethodListPage
} from 'domains/payment-method'

import {
  FastSellPaymentListPage,
  FastSellPaymentUpdatePage
} from 'domains/fast-sell-payment'
import {
  BankTransactionListPage,
  BankTransactionCreatePage,
  BankTransactionDetailPage,
  BankTransactionUploadCsvPage,
  BankTransactionDownloadSalesReconcileCsvPage,
  BankTransactionBulkEditPage
}  from 'domains/bank-transaction'
import { FinancePaymentsListPage } from 'domains/finance/payments/pages/list-page'
import { FinancePaymentsDetailPage } from 'domains/finance/payments/pages/detail-page'

const finance_team_routes = {
  collapse  : true,
  path      : '/finance',
  name      : 'Finance Team',
  icon      : 'fas fa-money-bill-wave text-green',
  state_key : 'finance_team_collapse',
  views     : [
    {
      path      : '/finance/payments/list',
      name      : 'Payment List',
      miniName  : 'P',
      component : FinancePaymentsListPage,
      layout    : '/app'
    },
    {
      path      : '/finance/payments/:id',
      name      : 'Payment Detail',
      miniName  : 'D',
      component : FinancePaymentsDetailPage,
      layout    : '/app',
      invisible : true
    },
    // {
    //   collapse  : true,
    //   name      : 'Orders',
    //   miniName  : 'O',
    //   state_key : 'finance_order_collapse',
    //   views     : [
    //     {
    //       path      : '/finance/orders/list',
    //       name      : 'List',
    //       component : CustomerOrderPaymentListPage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/orders/download-unlinked-bank-transaction-csv',
    //       name      : 'Download Unlinked Order CSV',
    //       component : CustomerOrdersDownloadUnlinkedBankTransactionCsvPage,
    //       layout    : '/app'
    //     }
    //   ]
    // },
    // {
    //   collapse  : true,
    //   name      : 'Payment Methods',
    //   miniName  : 'PM',
    //   state_key : 'payment_method_collapse',
    //   views     : [
    //     {
    //       path      : '/finance/payment_method',
    //       name      : 'List',
    //       component : PaymentMethodListPage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/payment_method/:paymentMethodId',
    //       name      : 'Detail',
    //       component : PaymentMethodDetailPage,
    //       layout    : '/app',
    //       invisible : true
    //     }
    //   ]
    // },
    // {
    //   collapse  : true,
    //   name      : 'Payment Bank Transfer',
    //   miniName  : 'PBTrans',
    //   state_key : 'payment_bank_transfer_collapse',
    //   views     : [
    //     {
    //       path      : '/finance/orders/payments/bank_transfer/list',
    //       name      : 'List',
    //       component : PaymentBankTransferListPage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/orders/payments/bank_transfer/create',
    //       name      : 'Create',
    //       component : PaymentBankTransferCreatePage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/orders/payments/bank_transfer/:id',
    //       component : PaymentBankTransferConfirmRejectPage,
    //       layout    : '/app',
    //       invisible : true
    //     }
    //   ]
    // },
    // {
    //   collapse  : true,
    //   name      : 'Refund',
    //   miniName  : 'Ref',
    //   state_key : 'refund_collapse',
    //   views     : finance_team_refund_routes
    // },
    // {
    //   collapse  : true,
    //   name      : 'Revenue',
    //   miniName  : 'SR',
    //   state_key : 'revenue_collapse',
    //   views     : [
    //     {
    //       path      : '/finance/sellers/revenues',
    //       name      : 'Seller',
    //       component : RevenueListPage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/merchants/revenues',
    //       name      : 'Merchant',
    //       component : RevenueListPage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/revenues/fast-sell-payment/list',
    //       name      : 'Fast Sell Payment list',
    //       component : FastSellPaymentListPage,
    //       layout    : '/app'
    //     }
    //   ]
    // },
    // {
    //   path      : '/finance/revenues/:id',
    //   name      : 'Revenue Detail',
    //   component : RevenueDetailPage,
    //   layout    : '/app',
    //   invisible : true
    // },
    // {
    //   path      : '/finance/revenues/:id/transfer',
    //   name      : 'Revenue Transfer',
    //   component : RevenueTransferPage,
    //   layout    : '/app',
    //   invisible : true
    // },
    // {
    //   path      : '/finance/revenues/fast-sell-payments/update/:fastSellProductId',
    //   name      : 'Payment Update',
    //   component : FastSellPaymentUpdatePage,
    //   layout    : '/app',
    //   invisible : true
    // },
    // {
    //   collapse  : true,
    //   name      : 'Bank Transactions',
    //   miniName  : 'BTransactions',
    //   state_key : 'bank_transactions_collapse',
    //   views     : [
    //     {
    //       path      : '/finance/bank-transactions/list',
    //       name      : 'List',
    //       component : BankTransactionListPage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/bank-transactions/create',
    //       name      : 'Create',
    //       component : BankTransactionCreatePage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/bank-transactions/upload-csv',
    //       name      : 'Upload Bank Statement CSV',
    //       component : BankTransactionUploadCsvPage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/bank-transactions/download-sales-reconcile-csv',
    //       name      : 'Download Sales Reconcile CSV',
    //       component : BankTransactionDownloadSalesReconcileCsvPage,
    //       layout    : '/app'
    //     },
    //     {
    //       path      : '/finance/bank-transactions/bulk-edit',
    //       name      : 'Bank Transaction Bulk Edit',
    //       component : BankTransactionBulkEditPage,
    //       layout    : '/app',
    //       invisible : true
    //     },
    //     {
    //       path      : '/finance/bank-transactions/:bankTransactionId',
    //       name      : 'Bank Transaction Detail',
    //       component : BankTransactionDetailPage,
    //       layout    : '/app',
    //       invisible : true
    //     }
    //   ]
    // }
  ]
}

export default finance_team_routes
